import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";

export const Loader: React.FC = () => {
  return (
    <Container>
      <Left>
        <Skeleton height={45} width={70} />
        <Skeleton height={15} width={90} />
      </Left>
      <Divider />
      <Right>
        <Skeleton height={16} width={120} />
        <Skeleton height={16} width={110} />
        <Skeleton height={16} width={50} />
      </Right>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 15px;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

const Divider = styled.div`
  background: var(--border-color);
  width: 1px;
  height: 80px;
  margin: 0 15px;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
